import moment from "moment";
import React, { useState, forwardRef, useImperativeHandle, useRef, useEffect } from "react";
import { Send, RefreshCcw } from "react-feather";
import { Button, Card, CardBody, CardFooter, CardHeader } from "reactstrap";
import { humanDateFormat, humanTimeFormat } from "../../../config/constants";
import useFetcher from "../../hooks/useFetcher";
import useMutter from "../../hooks/useMutter";
import { BlurSpinner } from "../BlurSpinner";
import { fetchActivity, addActivity } from "../../services/activityServices";

export const Activities = forwardRef(({ bodyStyle, entity, entityId, editable = true, hideHeader }, ref) => {
  // eslint-disable-next-line max-len
  const activityDetail = useRef(null);
  const [activities, isLoadingActivities, errorLoadingActivities, setActivities, refreshActivities] = useFetcher(fetchActivity, [{ entity, entityId }]);
  const [comment, setComment] = useState("");
  const [addCommentCall, isSavingComment] = useMutter(addActivity, [{ entity, entityId }]);
  const scrollToBottom = () => {
    activityDetail.current.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [activities]);

  useImperativeHandle(ref, () => ({
    refreshActivities,
  }));

  const addComment = async () => {
    const [result] = await addCommentCall({ entity, entityId, comment });
    if (result) {
      setComment("");
      setActivities([...activities, result]);
    }
  };

  const handleChangeComment = (event) => {
    setComment(event.target.value);
  };

  const handleCommentKeyDown = (event) => {
    if (event.key === "Enter" && comment !== "") {
      addComment([entityId, comment]);
    }
  };

  const handleCommentSend = () => {
    addComment([entityId, comment]);
  };

  return (
    <BlurSpinner isLoading={isLoadingActivities || errorLoadingActivities || isSavingComment}>
      <Card className="h-100 mb-0">
        {hideHeader !== true && (
          <CardHeader className="pt-3 pb-2 d-flex justify-content-between align-items-center">
            <h6 className="">Actividad:</h6>
            <Button color="link" size="xs" onClick={refreshActivities}>
              <RefreshCcw size="24" color="var(--secondary)" />
            </Button>
          </CardHeader>
        )}
        <CardBody className="recent-notification pb-0 custom-scrollbar" style={bodyStyle}>
          {activities.map((activity) => (
            <div className="d-flex justify-content-between border-bottom media" key={activity.id}>
              <p className="text-center mb-1">
                <small>
                  <b>{moment(activity.createdAt).format(humanDateFormat)}</b>
                </small>
                <br />
                {moment(activity.createdAt).format(humanTimeFormat)}
              </p>
              <div
                className="text-left mb-1 media-body"
                style={{
                  fontSize: "13px",
                  lineHeight: "1.7",
                  letterSpacing: "0.7px",
                }}
              >
                <span className="text-break">{activity.description}</span>
                <p className="f-12">{activity.usuario ? `${activity.usuario.nombre} ${activity.usuario.apellido}` : "Sistema"}</p>
              </div>
            </div>
          ))}
          <div ref={activityDetail} />
        </CardBody>
        {editable ? (
          <CardFooter className="p-1">
            <div className="input-group">
              <input
                id="chatInputTicket"
                type="text"
                className="form-control"
                placeholder="Ingrese aqui su comentario"
                aria-label="Comentario a enviar"
                value={comment}
                onChange={handleChangeComment}
                onKeyDown={handleCommentKeyDown}
              />

              <div className="input-group-append">
                <Button size="xs" outline onClick={handleCommentSend} disabled={comment === ""}>
                  <Send size="24" className="margin-auto" />
                </Button>
              </div>
            </div>
          </CardFooter>
        ) : null}
      </Card>
    </BlurSpinner>
  );
});
